"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Buttons = require("./../Buttons");

var _propTypes = require("prop-types");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  display: flex;\n  align-items: center;\n  height: 100%;\n\n  input {\n    border: none;\n    background-color: inherit;\n  }\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  border-left: 1px solid ", ";\n  padding-left: 2rem;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  width: 100%;\n  height: 100%;\n  box-sizing: border-box;\n  display: flex;\n  justify-content: space-between;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  background-color: #f7f7f7;\n  height: 7.5rem;\n  justify-content: space-between;\n  align-items: center;\n  padding: 18px 9.7vw 17px 1.56vw;\n  box-sizing: border-box;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Box = _styledComponents.default.div(_templateObject());

var Wrapper = _styledComponents.default.div(_templateObject2());

var ButtonWrapper = _styledComponents.default.div(_templateObject3(), function (_ref) {
  var theme = _ref.theme;
  return theme.ui.outline;
});

ButtonWrapper.displayName = 'ButtonWrapper';

var InnerBox = _styledComponents.default.div(_templateObject4());

InnerBox.displayName = 'InnerBox';

var ToolBar = function ToolBar(_ref2) {
  var btnName = _ref2.btnName,
      btnDisable = _ref2.btnDisable,
      className = _ref2.className,
      children = _ref2.children,
      level = _ref2.level,
      onClick = _ref2.onClick,
      otherProps = _objectWithoutProperties(_ref2, ["btnName", "btnDisable", "className", "children", "level", "onClick"]);

  return _react.default.createElement(Box, _extends({
    className: className
  }, otherProps), _react.default.createElement(Wrapper, null, _react.default.createElement(InnerBox, null, children), _react.default.createElement(ButtonWrapper, null, _react.default.createElement(_Buttons.ActionButton, {
    disabled: btnDisable,
    level: level,
    onClick: onClick,
    padding: "0.5rem 1.5rem"
  }, btnName))));
};

ToolBar.defaultProps = {
  btnName: 'New claim',
  level: 'primary',
  btnDisable: false,
  onClick: Function.prototype,
  otherProps: {}
};
ToolBar.propTypes = {
  /** Button name */
  btnName: _propTypes.string,

  /** Disable button */
  btnDisable: _propTypes.bool,

  /** Beeing able to use it in Styled Components */
  className: _propTypes.string,
  level: _propTypes.string,
  onClick: _propTypes.func,

  /** Adds extra props to the element */
  otherProps: _propTypes.object,
  children: _propTypes.node
};
ToolBar.displayName = 'ToolBar';
var _default = ToolBar;
exports.default = _default;